module.exports = __webpack_public_path__ + "static/img/logo1.1.df8ba5ae.png";